import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawalconfirmPage } from './withdrawalconfirm';

@NgModule({
  declarations: [
    WithdrawalconfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawalconfirmPage),
  ],
})
export class WithdrawalconfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdrawalconfirm/withdrawalconfirm.module.ts